import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { ChevronRight } from "@faire/web--source/slate/icons/Chevron";
import { CartEmpty } from "@faire/web--source/slate/icons/foundation/CartEmpty";
import { Row } from "@faire/web--source/slate/Layout";
import { getSpacing, Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import React from "react";
import styled from "styled-components";
export var BrandBagButton = function(param) {
    var showSidecart = param.showSidecart, totalInCart = param.totalInCart, setCart = param.setCart, isBrandPage = param.isBrandPage;
    var isTabletAndBelow = useViewport().isTabletAndBelow;
    if (isTabletAndBelow) {
        return null;
    }
    if (showSidecart) {
        return /*#__PURE__*/ _jsxs(BagButton, {
            onClick: setCart,
            $applyGreyBorder: isBrandPage,
            children: [
                /*#__PURE__*/ _jsx(Typography, {
                    children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                        id: "5FBC9w",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "Hide brand cart"
                            }
                        ]
                    })
                }),
                /*#__PURE__*/ _jsx(Spacer, {
                    size: "1x"
                }),
                /*#__PURE__*/ _jsx(ChevronRight, {
                    fontSize: "12px "
                })
            ]
        });
    }
    if (totalInCart && totalInCart > 0) {
        return /*#__PURE__*/ _jsxs(BagButton, {
            onClick: setCart,
            $applyGreyBorder: isBrandPage,
            children: [
                /*#__PURE__*/ _jsx(IconContainer, {
                    children: /*#__PURE__*/ _jsx(InvertedCart, {
                        fontSize: "16px",
                        strokeWidth: 1.5
                    })
                }),
                /*#__PURE__*/ _jsx(Spacer, {
                    size: "1x"
                }),
                /*#__PURE__*/ _jsx(Typography, {
                    children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                        id: "Ip0BT3",
                        defaultMessage: [
                            {
                                type: 6,
                                value: "totalInCartNumber",
                                options: {
                                    one: {
                                        value: [
                                            {
                                                type: 7
                                            },
                                            {
                                                type: 0,
                                                value: " product"
                                            }
                                        ]
                                    },
                                    other: {
                                        value: [
                                            {
                                                type: 7
                                            },
                                            {
                                                type: 0,
                                                value: " products"
                                            }
                                        ]
                                    }
                                },
                                offset: 0,
                                pluralType: "cardinal"
                            }
                        ],
                        values: {
                            totalInCartNumber: totalInCart
                        }
                    })
                })
            ]
        });
    }
    return /*#__PURE__*/ _jsx(BagButton, {
        onClick: setCart,
        "data-test-id": "brand-bag-toggle",
        $applyGreyBorder: isBrandPage,
        children: /*#__PURE__*/ _jsx(InvertedCart, {
            fontSize: "16px",
            strokeWidth: 1.5
        })
    });
};
var IconContainer = styled.div.withConfig({
    componentId: "sc-3e95ef10-0"
})([
    "height:32px;position:relative;display:flex;align-items:center;justify-content:flex-end;"
]);
var BagButton = styled(Row).attrs({
    justify: "center",
    align: "center"
}).withConfig({
    componentId: "sc-3e95ef10-1"
})([
    "height:",
    ";padding:",
    ";margin-left:",
    ";border-radius:100px;border:1px solid ",
    ";&:hover{cursor:pointer;background-color:",
    ";}"
], getSpacing("5x"), getSpacing(10, "2x", 10, "2x"), getSpacing("2x"), function(props) {
    return props.$applyGreyBorder ? Core.border.muted : Core.border.default;
}, Core.surface.muted);
var InvertedCart = styled(CartEmpty).withConfig({
    componentId: "sc-3e95ef10-2"
})([
    "transform:scaleX(-1);"
]);
